(() => {
  window.DigitalizModules = window.DigitalizModules || {};
  if (window.DigitalizModules.drawers) return;
  window.DigitalizModules.drawers = true;

  const OPEN_ATTR = "data-drawer-open";
  const CLOSE_ATTR = "data-drawer-close";
  const FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const lastTriggerByDrawer = new Map();

  function setExpanded(drawerId, expanded) {
    document.querySelectorAll(`[${OPEN_ATTR}="${drawerId}"]`).forEach((trigger) => {
      if (!(trigger instanceof HTMLElement)) return;
      trigger.setAttribute("aria-expanded", expanded ? "true" : "false");
    });
  }

  function openDrawerById(drawerId, trigger) {
    const target = document.getElementById(drawerId);
    if (!target) return;
    document.querySelectorAll(".theme-drawer.is-open").forEach((drawer) => {
      if (drawer.id !== drawerId) closeDrawerById(drawer.id, false);
    });
    // Digitaliz.openDrawer also locks the page scroll (body.drawer-open); the
    // fallback only toggles the classes.
    if (window.Digitaliz) {
      window.Digitaliz.openDrawer(drawerId);
    } else {
      target.classList.add("is-open");
      document.body.classList.add("drawer-open");
    }
    if (trigger instanceof HTMLElement) lastTriggerByDrawer.set(drawerId, trigger);
    setExpanded(drawerId, true);
    target.setAttribute("aria-hidden", "false");
    trapFocus(target);
  }

  function closeDrawerById(drawerId, restoreFocus = true) {
    if (!drawerId) return;
    if (window.Digitaliz) {
      window.Digitaliz.closeDrawer(drawerId);
    } else {
      const target = document.getElementById(drawerId);
      if (target) target.classList.remove("is-open");
      if (!document.querySelector(".theme-drawer.is-open")) {
        document.body.classList.remove("drawer-open");
      }
    }
    const target = document.getElementById(drawerId);
    if (target) target.setAttribute("aria-hidden", "true");
    setExpanded(drawerId, false);
    if (restoreFocus) {
      const trigger = lastTriggerByDrawer.get(drawerId);
      if (trigger instanceof HTMLElement) trigger.focus();
    }
  }

  function trapFocus(drawer) {
    if (drawer.dataset.focusTrapBound === "true") return;
    drawer.dataset.focusTrapBound = "true";

    drawer.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeDrawerById(drawer.id);
        return;
      }

      if (event.key !== "Tab") return;
      const focusables = [...drawer.querySelectorAll(FOCUSABLE_SELECTOR)];
      if (!focusables.length) return;

      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function focusFirst(drawer) {
    const first = drawer.querySelector(FOCUSABLE_SELECTOR);
    if (first instanceof HTMLElement) {
      first.focus();
    } else {
      drawer.focus();
    }
  }

  function init() {
    document.querySelectorAll(`[${OPEN_ATTR}]`).forEach((trigger) => {
      if (trigger.dataset.drawerOpenBound === "true") return;
      trigger.dataset.drawerOpenBound = "true";
      trigger.addEventListener("click", () => {
        const targetId = trigger.getAttribute(OPEN_ATTR);
        openDrawerById(targetId, trigger);
        const drawer = targetId ? document.getElementById(targetId) : null;
        if (drawer) focusFirst(drawer);
      });
    });

    document.querySelectorAll(`[${CLOSE_ATTR}]`).forEach((trigger) => {
      if (trigger.dataset.drawerCloseBound === "true") return;
      trigger.dataset.drawerCloseBound = "true";
      trigger.addEventListener("click", () => {
        const targetId = trigger.getAttribute(CLOSE_ATTR);
        closeDrawerById(targetId);
      });
    });

    const backdrop = document.querySelector("[data-drawer-backdrop]");
    if (backdrop && backdrop.dataset.drawerBackdropBound !== "true") {
      backdrop.dataset.drawerBackdropBound = "true";
      backdrop.addEventListener("click", () => {
        document.querySelectorAll(".theme-drawer.is-open").forEach((drawer) => {
          closeDrawerById(drawer.id, false);
        });
      });
    }

    document.querySelectorAll(".theme-drawer").forEach((drawer) => {
      drawer.setAttribute("aria-hidden", drawer.classList.contains("is-open") ? "false" : "true");
    });
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
